import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["innerHTML"]
const _hoisted_2 = { class: "_grid _grid-cols-1 _grid-cols-3--m _gap-5" }
const _hoisted_3 = { class: "_tc--light-gray gfu-bt--b1" }
const _hoisted_4 = { class: "_tac _mt-6 gfu-bt--b1" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_base_title = _resolveComponent("base-title")
  const _component_base_text = _resolveComponent("base-text")
  const _component_box = _resolveComponent("box")

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_base_title, {
      as: "h3",
      level: "h2"
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.Resources.PledgeManager.SectionSetupStepsTitle), 1 /* TEXT */)
      ]),
      _: 1 /* STABLE */
    }),
    _createElementVNode("div", {
      class: "_mb-6 gfu-bt--b1",
      innerHTML: $props.setupStepsDescription
    }, null, 8 /* PROPS */, _hoisted_1),
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.steps, (step) => {
        return (_openBlock(), _createBlock(_component_box, {
          key: step.stepNumber
        }, {
          default: _withCtx(() => [
            _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.Resources.PledgeManager.StepLabel) + " " + _toDisplayString(step.stepNumber), 1 /* TEXT */),
            _createVNode(_component_base_title, {
              as: "h3",
              class: "_my-1"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(step.title), 1 /* TEXT */)
              ]),
              _: 2 /* DYNAMIC */
            }, 1024 /* DYNAMIC_SLOTS */),
            _createVNode(_component_base_text, {
              as: "p",
              level: "b1",
              class: "_mt-0"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(step.description), 1 /* TEXT */)
              ]),
              _: 2 /* DYNAMIC */
            }, 1024 /* DYNAMIC_SLOTS */)
          ]),
          _: 2 /* DYNAMIC */
        }, 1024 /* DYNAMIC_SLOTS */))
      }), 128 /* KEYED_FRAGMENT */))
    ]),
    _createElementVNode("p", _hoisted_4, _toDisplayString($props.summary), 1 /* TEXT */)
  ]))
}